// Country specific JS
// All your code here should be wrapped inside functions, i.e. no code a the root of the module (beside empty variable declarations)

// here you can import other things
// import { myfunction } from './lib/mylib'

export function init() {
  // type your code here
  // it will be executed on the DOMContentLoaded event

  //SWOGO BASKET
  const swogobox = document.createElement('div');
  swogobox.id = 'swogo-bundle-0';
  swogobox.className = 'swogo-box';

  const swogobasket = document.getElementById('cartridgeDivId');
  const swogobasketafter = document.querySelector('.dkt-checkout-actions');
  const swogobasketmobile = document.querySelector('.checkout-cart__cart-title-container');
  const swogobasketmobileafter = document.querySelector('.checkout-cart__cart-title');

  if (window.innerWidth < 900 && swogobasketmobileafter){
    swogobasketmobile.insertBefore(swogobox, swogobasketmobileafter);
  }

  else if (swogobasketafter){ 
    swogobasket.insertBefore(swogobox, swogobasketafter.nextSibling);
  }
}



// WEBPACK FOOTER //
// ./src/_override/checkout/checkout-country.entry.js